const summaryFilterOptionsConstants = {
  INDEX: 'SUMMARYFILTEROPTIONS_INDEX',
  INDEX_FAIL: 'SUMMARYFILTEROPTIONS_INDEX_FAIL',
  INDEX_SUCCESS: 'SUMMARYFILTEROPTIONS_INDEX_SUCCESS',
  // The limit here is being increased for Generac
  // https://app.clickup.com/t/86dx2heg8.
  // As of 19th June 2025, Generac has
  // 1335 distinct option values for `dealer`
  // but this is a somewhat unique case
  // (the option field used to be a text field,
  // so there are lots of similar-but-different values)
  // and now only "sanctioned" options can be selected
  // from a list under admin control
  // in which there are 182 entries.
  // This change will allow that sancitoned 182
  // to increase up to 447 which should hopefully
  // be enough headroom for Generac for now.
  PAGING_SIZE: 1600
};
summaryFilterOptionsConstants.SET_CURRENT = 'SUMMARY_SET_CURRENT';
export default summaryFilterOptionsConstants;